module.exports = __webpack_public_path__ + "static/client10-0061a8c19f8e3de7c1b148ba6034b999.png";